<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">إدخال فيديو</h5>

                       <span> بالرجاء ملئ جميع الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "videoForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                            <!-- title  -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> الأسم</label>
                                <input class="form-control" id="validation01" type="text" formControlName="titleAr"
                                [tooltip]="fc.titleAr.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.titleAr.valid && (fc.titleAr.touched)"
                                [class.is-invalid]="fc.titleAr.invalid && (fc.titleAr.touched)"
                               
                                     required
                                     placeholder="الأسم"
                                    containerClass="" />
                            </div>
                            <!-- <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> الأسم</label>
                                <input class="form-control" id="validation01" type="text" formControlName="title"
                                [tooltip]="fc.title.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.title.valid && (fc.title.touched)"
                                [class.is-invalid]="fc.title.invalid && (fc.title.touched)"
                               
                                     required
                                     placeholder="الأسم"
                                    containerClass="" />
                            </div> -->
                            <!-- youtube url   -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> رابط الفيديو</label>
                                <input class="form-control" id="validation01" type="text" formControlName="youtubeVideoUrl"
                                [tooltip]="fc.youtubeVideoUrl.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.youtubeVideoUrl.valid && (fc.youtubeVideoUrl.touched)"
                                [class.is-invalid]="fc.youtubeVideoUrl.invalid && (fc.youtubeVideoUrl.touched)"
                                
                                     required
                                     placeholder="https://www.example.com"
                                    containerClass="" />
                            </div>
                          <!-- video album   -->
                            <div class="col-6 mb-3">
                                <label for="validationCustom05"><span class="validation-required">*</span> ملف الفيديو</label>
                                <ng-select #Governorate  [selectOnTab]="true" formControlName="videoAlbumId"
                                    class="form-control p-0" placeholder="اختر ملف الفيديو"
                                    containerClass="" 
                                    id="validationCustom05">
                                    <ng-option *ngFor="let item of videoes  " [value]="item.id">{{item.titleAr}}</ng-option>
                                </ng-select>
                            </div>
                        
                        </div>
                        
                  
                        <ng-template #elseBlock>
                            <button [disabled]="button" class="btn pull-right" type="submit">
                               حفظ
                            </button>
                            </ng-template>
                        <div *ngIf="update; else elseBlock">
                            <button class="btn  pull-right" type="submit">
                                تعديل
                            </button>
                       </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

